import { render, staticRenderFns } from "./setPass.vue?vue&type=template&id=35be07ce&scoped=true"
import script from "./setPass.vue?vue&type=script&lang=js"
export * from "./setPass.vue?vue&type=script&lang=js"
import style0 from "./setPass.vue?vue&type=style&index=0&id=35be07ce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35be07ce",
  null
  
)

export default component.exports